console.log("✅ External script is loaded!");

document.addEventListener("DOMContentLoaded", function() {
    console.log("✅ Document fully loaded, script running...");

    let variantDataElement = document.querySelector("#variant-data");
    if (!variantDataElement) {
        console.error("❌ Variant JSON data is missing.");
        return;
    }

    let variantData;
    try {
        variantData = JSON.parse(variantDataElement.textContent);
        console.log("✅ Variant Data Loaded:", variantData);
    } catch (error) {
        console.error("❌ Error parsing variant data:", error);
        return;
    }

    const strengthDropdowns = document.querySelectorAll('.quantity-break__variant-select'); 
    if (strengthDropdowns.length < 2) {
        console.error("❌ Not enough strength level dropdowns found.");
        return;
    }

    const strengthDropdown1 = strengthDropdowns[0]; // First strength selector (user-controlled)
    const strengthDropdown2 = strengthDropdowns[1]; // Second strength selector (auto-updated)

    console.log("🟡 Strength Dropdown 1 Found:", strengthDropdown1);
    console.log("🟡 Strength Dropdown 2 Found:", strengthDropdown2);

    function updateSecondVariant() {
        if (!strengthDropdown1 || !strengthDropdown2) {
            console.error("❌ Dropdown elements not found.");
            return;
        }

        let selectedValue = strengthDropdown1.value;
        console.log("🟡 First variant selected:", selectedValue);

        // 🔄 Now we ONLY update dropdown 2 while keeping dropdown 1 unchanged
        let alternativeVariant = Array.from(strengthDropdown2.options).find(option => option.value !== selectedValue);
        
        if (alternativeVariant) {
            console.log("🟢 Second dropdown auto-selected:", alternativeVariant.value);
            strengthDropdown2.value = alternativeVariant.value;
            strengthDropdown2.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
            console.warn("⚠️ No alternative variant found for dropdown 2!");
        }
    }

    // Auto-update when dropdown 1 is changed
    strengthDropdown1.addEventListener("change", updateSecondVariant);

    // Force update when the page loads
    updateSecondVariant();
});
